import SpriteSymbol from "../../../../dev-d21-front/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../dev-d21-front/node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "logo1",
  "use": "logo1-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 200 200\" id=\"logo1\"><text x=\"50%\" y=\"50%\" fill=\"#fff\" dominant-baseline=\"middle\" font-family=\"system-ui, sans-serif\" font-size=\"180\" text-anchor=\"middle\">J</text></symbol>"
});
var result = sprite.add(symbol);
export default symbol